import { useClassroomTestRoundReportQuery } from '@innovamat/glow-api-client';

type Props = {
  testRoundId: string;
  language: string;
};

type UseTestReport = {
  pdfBase64: string|null;
  isLoading: boolean;
  isError: boolean;
  error: unknown;
  is404Error: boolean;
};

function useTestReport({ testRoundId, language }: Props): UseTestReport {
  const { data, isLoading, isError, error } = useClassroomTestRoundReportQuery(
    {
      testRoundId,
      language,
    },
    {
      retry: false,
      enabled: !!testRoundId && !!language,
      staleTime: Infinity,
    }
  );

  const is404Error = (error as any)?.response?.errors?.some(
    (err: any) => err?.extensions?.response?.status === 404
  );

  return {
    pdfBase64: data?.classroomTestRoundReport?.pdfBase64 || null,
    isLoading,
    isError,
    error,
    is404Error,
  };
}

export { useTestReport };
